import isProd from './isProduction'

export const props = (prod = isProd()) => ({
  cfeApiUrl: prod ? 'https://www.bibme.org/api' : '//playground.bibme.org/api',
  wptAppUrl: prod ? 'https://writing.bibme.org' : '//writing-playground.bibme.org',
  wptApiUrl: prod ? 'https://wbe-prod-api.bibme.org' : '//writing-backend.playground.bibme.org',
  cfeAuth: true,
})

export default function getWidgetProps({
  theme = 'bibme',
  headingText = 'Try our smart proofreader',
  // eslint-disable-next-line max-len
  subheadingText = `Don't worry, your writing won't be searchable publicly or in any other database. No other plagiarism checkers will see your paper.`,
} = {}) {
  return {
    theme,
    headingText,
    subheadingText,
    ...props(),
  }
}
